import { render, staticRenderFns } from "./Sandflox.vue?vue&type=template&id=0e6307c1&scoped=true&"
import script from "./Sandflox.vue?vue&type=script&lang=ts&"
export * from "./Sandflox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6307c1",
  null
  
)

export default component.exports